import React, { ReactElement } from 'react';
import Styled from './Box.styled';
import { ComponentProps as Props, GroupComponent } from './Box.types';
import Header from './Header/Header';
import Content from './Content/Content';
import Footer from './Footer/Footer';

export const Box: React.FC<Props> & GroupComponent = ({ children, title, ...props }): ReactElement<Props> => {
  return (
    <Styled borderRadius={1} bg="var(--color-extra-white)" {...props}>
      {title && <Header title={title} />}
      {children}
    </Styled>
  );
};

Box.Header = Header;
Box.Content = Content;
Box.Footer = Footer;

export default Box;
